export default __webpack_public_path__ + "static/media/bg-plans.03b7714f.svg";